import { API_URL } from "../../services/api";
import axios from "axios";

const headers = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token.token}`,
        },
    };
};

export const create = (data, token) => {
    return axios
        .post(API_URL + "form/companies", data, headers(token))
        .then((response) => {
            return {
                success: true,
                message: "Guardado",
            };
        })
        .catch((error) => {
            return {
                success: false,
                message: "Error al guardar",
            };
        });
};

export const get = (token) => {
    return axios
        .get(API_URL + "companies/pagination", headers(token))
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return {
                success: false,
                message: "Error",
                data: response.data,
            };
        });
};

export const update = (company, id, token) => {
    const data = {
        company: company,
        _method: "put",
    };

    return axios
        .post(API_URL + "form/companies/" + id, data, headers(token))
        .then((response) => {
            return {
                success: response.data.success,
                message: response.data.message,
            };
        })
        .catch((error) => {
            console.log(error);
            return {
                success: error.success,
                message: error.message,
            };
        });
};

export default create;
